import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import FileDownload from 'react-file-download';
import PpcUsersList from './ppc-list';
import PpcSearch from './ppc-search';
import { getPpcManagementList } from '../../../../actions/ppc';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import irelandApi from '../../../../irelandApi';

class PpcManagement extends Component {
  handleInputChange = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      searchValue, dateFrom, dateTo, pageNumber
    } = this.state;

    dispatch(getPpcManagementList(searchValue, dateFrom, dateTo, pageNumber));
  };

  handleClear = () => {
    this.setState({
      searchValue: '',
      dateFrom: '',
      dateTo: '',
      pageNumber: 1
    }, this.handleSearch);
  };

  handlePageChange = (page) => {
    this.handleSearch();
    this.setState({ pageNumber: page });
  };

  downloadCSV = (url) => {
    irelandApi.get(url, { headers: { Accept: 'text/csv' } })
      .then((response) => {
        FileDownload(response.data, 'unprocessed_ppc_orders.csv');
      })
      .catch(() => {});
  };

  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      dateFrom: '',
      dateTo: '',
      pageNumber: 1
    };
  }

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getPpcManagementList());
  }

  render() {
    const {
      links,
      fetched,
      fetching,
      pagination,
      users
    } = this.props;
    const {
      dateFrom,
      dateTo,
      searchValue,
      pageNumber
    } = this.state;

    return (
      <Container fluid className="ppc-management">
        <Row>
          <Col md={12}>
            <PageTitle className="float-start">
              Prepaid card management
            </PageTitle>
            <ArrowButton
              arrow={false}
              className="float-end"
              onClick={() => {
                this.downloadCSV(links['unprocessed-orders']);
              }}
              submit={false}
            >
              Unprocessed orders
            </ArrowButton>
          </Col>
        </Row>
        <Row className="mg-top-10">
          <Col md={12}>
            <PpcSearch
              dateFromValue={dateFrom}
              dateToValue={dateTo}
              onClear={this.handleClear}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onInputChange={this.handleInputChange}
              onSearch={this.handleSearch}
              searchValue={searchValue}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PpcUsersList
              currentPage={pageNumber}
              fetched={fetched}
              fetching={fetching}
              onPageChange={this.handlePageChange}
              pagination={pagination}
              users={users}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  users: state.ppc.management.list,
  pagination: state.ppc.management.paging,
  links: state.ppc.management.links,
  fetching: state.ppc.fetching,
  fetched: state.ppc.fetched
});

export default connect(mapStateToProps)(PpcManagement);
